<div class="card bcx-card h-100">
  <div class="card-body p-4">
    <h6 class="card-title fw-bold mb-3">Summary Snapshot</h6>

    <div class="table-responsive">
      <table class="table table-borderless mb-0">
        <tbody>
          <tr v-for="(item, index) in summary_items" :key="index">
            <td class="py-2 text-secondary text-xs">
              {{ item.label }}
            </td>

            <td class="py-2 text-end fw-bold text-xs">
              {{ item.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
